export const formatEmail=(email)=>{
    const [localPart, domain] = email.split("@");
    try {
        const maskedLocalPart =
        localPart.slice(0, 3) + "*".repeat(localPart.length - 4) + localPart.slice(-1);
        const domainParts = domain.split(".");
        const maskedDomain =
            domainParts[0].slice(0, 3) + "*".repeat(domainParts[0].length - 3);

        return `${maskedLocalPart}@${maskedDomain}.${domainParts[1]}`;
    } catch (error) {
        return `${"*".repeat(localPart.length)}@${domain}`
    }
    
}
export const superRedactEmail=(email)=>{
    const parts = email.split('@');
    const localPart = parts[0];
    const domain = parts[1];

    // Redact the local part except for the first character
    const redactedLocalPart = localPart.slice(0,1)+localPart.slice(1).replace(/./g, '*');

    // Redact the domain except for the TLD
    const tld = domain.split('.').pop();
    const redactedDomain = domain.slice(0,1)+'******';
    const redactedTLD = tld.slice(0,1)+tld.slice(1).replace(/./g, '*');

    return `${redactedLocalPart}@${redactedDomain}.${redactedTLD}`;
}